import React from "react";
import { toFarsiNumber } from "../../helper/helper";
import logo from "../../images/header-logo.png";

const Frame = ({ page, user }) => {
  return (
    <>
      {/* left */}
      <div className="w-1 h-full border-r-2 border-gray-700 border-dashed absolute left-4 z-10 top-0"></div>
      {/* right */}
      <div className="w-1 h-full border-r-2 border-gray-700 border-dashed absolute right-4 z-10 top-0"></div>
      {/* top */}
      <div className="size-24 absolute left-2/4 -translate-x-2/4 z-20 top-0 border-2 bg-[#fff] border-dotted border-gray-700 rounded-full flex items-center justify-center">
        <img src={logo} className="w-16" alt="" />
      </div>
      <div className="w-full h-1 border-t-2 border-gray-700 border-dashed absolute left-0 z-10 top-[10px]"></div>

      {/* bottom */}
      <div className="w-full h-1 border-t-2 border-gray-700 border-dashed absolute left-0 z-10 bottom-16"></div>
      <div className="w-44 h-12 bg-yellow-700 text-gray-800 text-lg absolute left-0 bottom-4 z-10 flex justify-center items-center">
        myunibest.com
      </div>

      {/* circles */}
      <div className="gap-3 h-12 ml-3 absolute left-[180px] bottom-4 z-10 flex flex-row-reverse justify-center items-center">
        <span className="size-5 rounded-full bg-red-700"></span>
        <span className="size-5 rounded-full bg-yellow-700"></span>
        <span className="size-5 rounded-full bg-green-700"></span>
        <span className="size-5 rounded-full bg-blue-700"></span>
      </div>

      <div className="w-full h-1 border-t-2 border-gray-700 border-dashed absolute left-0 z-10 bottom-[10px]"></div>

      {/* user name */}
      <div className="w-44 h-12 text-gray-700 absolute right-0 bottom-4 z-10 flex items-center pr-9">
        {user?.user?.name + " " + user?.user?.family_name}
      </div>

      {/* page number */}
      <div className="h-12 text-lg text-gray-700 absolute left-2/4 -translate-x-2/4 bottom-4 z-10 flex items-center">
        {toFarsiNumber(page)}
      </div>
    </>
  );
};

export default Frame;
